export const siteTitle = 'Smart Tech Windows & Doors Winnipeg';

// --- Submission API -------------------------------------------------------
// One base URL drives the submit, the progressive-capture and the page-hide
// beacon endpoints.
//
// production build (`next build`) -> the production API.
// development (`npm run dev`)     -> OFF, so a local test never writes a real
//                                    row into the customer's lead pipeline.
//
// Override either default with NEXT_PUBLIC_FORM_API_BASE in .env.local:
//   NEXT_PUBLIC_FORM_API_BASE=https://subsapi.smarttechwindows.com
//   NEXT_PUBLIC_FORM_API_BASE=off      (explicitly post nowhere)
const PRODUCTION_API_BASE = 'https://subsapi.smarttechwindows.com';

const configuredApiBase = (process.env.NEXT_PUBLIC_FORM_API_BASE || '').trim();

const apiBase = (() => {
  if (configuredApiBase) {
    if (/^(off|none|false|0)$/i.test(configuredApiBase)) return '';
    return configuredApiBase.replace(/\/+$/, '');
  }
  return process.env.NODE_ENV === 'production' ? PRODUCTION_API_BASE : '';
})();

// False when the form must not post anywhere.
export const formApiEnabled = Boolean(apiBase);

export const formBackendUrl = apiBase ? `${apiBase}/submissions` : '';

// Progressive capture (values sent while typing) and the page-hide beacon.
// Both accept text/plain so the browser needs no CORS preflight.
export const partialBackendUrl = apiBase ? `${apiBase}/partial` : '';
export const beaconBackendUrl = apiBase ? `${apiBase}/submissions/beacon` : '';

// Pages that carry the quote form: a queued lead re-sent from one of these
// moves the visitor on to /thanks.
export const formPaths = /^\/?$/;

export const citiesForForm = [
  'Winnipeg',
  'Steinbach',
  'Selkirk',
  'Stonewall',
  'Niverville',
  'Oakbank',
];

export const sentryDsn = '';
